import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/site/PageHeader";
import { SERVICE_AREAS } from "@/data/site";
import { CTASection } from "@/components/site/CTASection";

export const Route = createFileRoute("/service-areas")({
  head: () => ({
    meta: [
      { title: "Wisconsin Painting Service Areas — Michael's Painting" },
      { name: "description", content: "Painting services across Madison, Sun Prairie, Middleton, Fitchburg, Verona, Waunakee, Stoughton, and surrounding Wisconsin communities." },
      { property: "og:title", content: "Wisconsin Painting Service Areas" },
      { property: "og:description", content: "Painting services across Wisconsin's largest cities and surrounding communities." },
      { property: "og:url", content: "https://michaelspaintingwi.com/service-areas" },
    ],
    links: [{ rel: "canonical", href: "https://michaelspaintingwi.com/service-areas" }],
  }),
  component: AreasPage,
});

function AreasPage() {
  return (
    <>
      <PageHeader eyebrow="Service Areas" title="Premium painting across Wisconsin." subtitle="We serve homeowners, property managers, and businesses statewide. If your community isn't listed, ask — we travel for the right project." />
      <section className="py-24 bg-brand-ivory">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {SERVICE_AREAS.map((c) => (
              <div key={c} className="p-6 rounded-md border border-zinc-200 bg-brand-ivory-soft hover:border-brand-brass transition-colors">
                <h2 className="font-serif text-2xl text-brand-navy">{c}</h2>
                <p className="text-xs uppercase tracking-widest text-zinc-500 mt-2">Wisconsin</p>
              </div>
            ))}
          </div>
          <div className="mt-12 text-center">
            <Link to="/contact" className="inline-flex bg-brand-navy text-brand-ivory px-7 py-3.5 rounded-sm text-sm font-semibold hover:bg-brand-navy-soft transition-colors">Request a Free Painting Estimate in Your Area</Link>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
